<template>
  <v-container class="pa-0">
    <v-card class="pa-3 ma-0" v-if="!loading">
      <vue-apex-charts type="bar" height="350" :options="chartOptions" :series="series" ></vue-apex-charts>
    </v-card>
    <v-card v-show="loading">
      <v-row align="center" justify="center" style="height: 350px;">
        <v-progress-circular :size="80" color="primary" indeterminate ></v-progress-circular>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "ChartAttendance",
  components: {
    VueApexCharts,
  },
  props: ["companyId", "week", "companyName"],
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      data: {},
      loading: false,
      series: [ {name: 'data', data: []}, ],
      chartOptions: {
        title: {
            text: '',
            align: 'center',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: { fontSize:  '14px', fontWeight:  'bold', color:  '#263238' },
        },
        chart: {
          type: "bar",
          height: 350,
          toolbar: { show: false, },
          zoom: { enabled: false, },
        },
        colors: ["#4CAF50", "#FF5252", "#FFC107", "#033A6D"],
        responsive: [
          {
            breakpoint: 480,
            options: { legend: { position: "bottom", offsetX: -10, offsetY: 0, }, },
          },
        ],
        dataLabels: { enabled: true, },
        plotOptions: { bar: { horizontal: false, }, },
        xaxis: { type: "label", categories: [], },
        tooltip: { x: { format: "dd MMM yyyy", }, },
        legend: { position: "top", },
        fill: { opacity: 1, },
      },
    };
  },
  methods: {
    async getData() {
      const body = {
        id: this.companyId,
        week: this.week,
        companyName: this.companyName
      }
      this.loading = true
      const result = await this.$store.dispatch('getChartDataAttendance', body)
      this.loading = false
      return result
    },
    refresh() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    },
    updateChart() {
      this.series = this.data.value ? this.data.value : [{name: 'Data', data: []}]
      this.chartOptions = {   
        ...this.chartOptions,
        ...{ xaxis: { categories: this.data.label ? this.data.label : [] } }
      }
      this.chartOptions.title.text = this.data.title
      this.refresh()
    }

  },
  computed: {
  },
  watch: {
    // async label() {
    //   this.data = await this.getData()
    //   this.updateChart()
    // },
  },
  async created() {
    if (this.companyId) {
      this.data = await this.getData()
      this.updateChart()
    }
  },
};
</script>
